import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="max-w-md mx-auto px-5 py-20 text-center" data-testid="not-found-page">
      <Compass size={40} className="mx-auto text-stone-400 mb-3" />
      <h1 className="heading text-3xl font-extrabold text-stone-900">Page not found</h1>
      <p className="text-stone-600 mt-2 break-all">Nothing lives at <code>{pathname}</code>.</p>
      <Link to="/" className="inline-block mt-6 rounded-full bg-[#2D5A27] text-white font-bold px-5 py-2.5" data-testid="not-found-home">Go home</Link>
    </div>
  );
}
